<template>
  <div class="footer-main flex-center-between" >
    <div class="left flex-column-start-center">
      <img :src="logoUrl" alt="" class="logo">

      <div class="label">{{ $t('yu-yan-xuan-ze') }}</div>
      <div class="lang-input flex-center-between" @click="toShowLang">
        {{langName}}
        <img :src="downUrl" alt="">
      </div>

      <div class="kefu flex-start">
        <div class="link" v-for="(item, i) in kefuList" :key="i" @click="chooseKefu(item)">
          <img :src="item.Avatar" alt="">
        </div>
      </div>
    </div>
    <div class="right flex-column-start-center">
      <div class="flex">
        <div class="link-box">
          <div class="title">{{ $t('guan-yu-fmall-ex') }}</div>
          <div class="link" @click="toPath('about')">{{ $t('pageTitle.about') }}</div>
          <div class="link" @click="toPath('agreement')">{{ $t('fu-wu-tiao-kuan') }}</div>
          <div class="link" @click="toPath('privacy')">{{ $t('pageTitle.privacy') }}</div>
          <div class="link" @click="toPath('statement')">{{ $t('mian-ze-shuo-ming') }}</div>
          <div class="link" @click="toPath('contract')" v-show="false">{{ $t('lian-xi-wo-men') }}</div>
          <div class="link" @click="toShowDownload" v-show="false">{{ $t('famll-ex-app') }}</div>
        </div>
        <div class="link-box">
          <div class="title">{{ $t('chan-pin') }}</div>
          <div class="link" @click="toPath('trade', {type: 2})">{{ $t('followDetail.label16') }}</div>
          <div class="link" @click="toPath('trade', {type: 3})">{{ $t('followDetail.label17') }}</div>
          <div class="link" @click="toPath('trade', {type: 1})">{{ $t('common.trade2') }}</div>
          <div class="link" @click="toPath('follow')" v-show="false">{{ $t('gen-dan-jiao-yi') }} </div>
          <div class="link" @click="toPath('imitate')">{{ $t('pageTitle.imitate') }}</div>

        </div>
        <div class="link-box">
          <div class="title">{{ $t('pageTitle.trade') }}</div>
          <div class="link" @click="toTrade('BTC', 1)">BTC/USDT</div>
          <div class="link" @click="toTrade('ETH', 2)">ETH/USDT</div>
          <div class="link" @click="toTrade('BNB', 4)">BNB/USDT</div>
          <div class="link" @click="toTrade('SOL', 9)">SOL/USDT</div>
          <div class="link" @click="toTrade('ADA', 6)">ADA/USDT</div>
          <div class="link" @click="toTrade('DOGE', 7)">DOGE/USDT</div>
        </div>
        <div class="link-box">
          <div class="title">{{ $t('yong-hu-zhi-chi') }}</div>
          <div class="link" @click="toPath('help')">{{ $t('pageTitle.help') }}</div>
          <div class="link" @click="toPath('feedback')">{{ $t('pageTitle.feedback') }}</div>
          <div class="link" @click="toPath('notice')">{{ $t('pageTitle.notice') }}</div>
          <div class="link" @click="toShowKefu">{{ $t('pageTitle.kefu') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from 'vant'
import { customerList } from '@/api/setting'
import { isQiabotNewType, openQiabotWidget, QIABOT_NEW_TYPE } from '@/utils/qiabot'
export default {
  components: {
    Icon
  },
  data() {
    return {
      logoUrl: require('../../assets/imgs/logo6.png'),
      downUrl: require('../../assets/imgs/icon-arrow-down.png'),
      kefuUrl1:  require('../../assets/imgs/icon-kefu1.png'),
      kefuUrl2:  require('../../assets/imgs/icon-kefu2.png'),
      kefuUrl3:  require('../../assets/imgs/icon-kefu3.png'),
      kefuUrl4:  require('../../assets/imgs/icon-kefu4.png'),
      lang: 'zh-CN',
      kefuList: []
    }
  },
  computed: {
    langName() {
      return this.$store.state.langName
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      //客服
      customerList().then(res => {
        this.kefuList = res.data.Items
      })
    },
    toPath(path, query) {
      if (path) {
        this.$router.push({
          name: path,
          query: query || {}
        })
      }
		},
    toShowKefu() {
      this.$store.state.footerClick = 'kefu'
    },
    toShowDownload() {
      this.$router.push({
        name: 'download'
      })
    },
    toShowLang() {
      this.$store.state.footerClick = 'lang'
    },
    toTrade(name, ID) {
      this.$router.push({
        name: 'trade',
        query: {
          name: name,
          id: ID,
          type: 2
        }
      })
    },
    chooseKefu(data) {
      this.to(data.Type, data.Link)
    },
    to(Type, Link) {
      let tmp = undefined
      let that = this
      if(isQiabotNewType(Type)) {
        window.localStorage.setItem('kefuType', QIABOT_NEW_TYPE)
        openQiabotWidget(Link).catch(error => {
          console.error('qiabot新版打开失败:', error)
        })
      } else if(Type == "chatwoot") {
        if(window.$chatwoot === undefined) {
          tmp = setInterval(function (){
            // that.chatwoot()
            if (window.$chatwoot !== undefined) {
              clearInterval(tmp)
              window.$chatwoot.toggle('open');
            }
          },50)
        } else {
          window.$chatwoot.toggle('open');
        }
      } else if (Type == 'meiqia') {
        this.$router.push({
          name: 'kefu'
        })
      } else if (Type === 'qiabot') {
        const match = Link && Link.match(/[?&]tag=([^&]+)/)
        const tag = match ? match[1] : ''
        this.toKefuPath('/qiabot.html' + (tag ? '?tag=' + tag : ''))
      } else {
        switch (Type) {
          case "wechat":
            Link = "weixin://" + Link
            break;
          case "qq":
            Link = "mqq://"+ Link
            break;
          case "whatsapp":
            Link = "whatsapp://send?phone="+ Link
            break;
          case "telegram":
            Link = "tg://resolve?domain="+ Link
            break;
          case "facebook":
            Link = "fb://"+ Link
            break;
          case "twitter":
            Link = "twitter://"+ Link
            break;
          case "instagram":
            Link = "instagram://"+ Link
            break;
            case "line":
            Link = "https://line.me/R/"+ Link
            break;
        }
        this.toKefuPath(Link)
      }
    },
    toKefuPath(path) {
      let a = document.createElement('a')
      a.href = path
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    chatwoot(Link){
      let that = this;
      if (Link.length === 0) {
        return;
      }
      let len = Link.indexOf("/widget");
      if (len === -1) {
        return;
      }
      var BASE_URL=Link.substr(0,len);
      let tokenlen = Link.indexOf("token=");
      let token = Link.substr(tokenlen+6);
      window.chatwootSDK.run({
        websiteToken: token,
        baseUrl: BASE_URL
      });
      that.inter = setInterval(function(){
        if(document.getElementsByClassName("woot-widget-bubble")[0] !== undefined) {
          that.show = true;
          clearInterval(that.inter);
          window.$chatwoot.toggleBubbleVisibility('hide');
        }
      },50);
    },
  }
}
</script>
